var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvertisements(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Advertisements",
    transform: "translate(-4902 -9556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2396",
    "data-name": "Rectangle 2396",
    transform: "translate(4902 9556)",
    fill: "none",
    stroke: "current",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 18,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3033",
    "data-name": "Group 3033",
    transform: "translate(4903.85 9557.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3032",
    "data-name": "Group 3032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3031",
    "data-name": "Group 3031",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2388",
    "data-name": "Rectangle 2388",
    width: 3,
    height: 3,
    transform: "translate(0.15 0.15)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2397",
    "data-name": "Rectangle 2397",
    width: 3,
    height: 3,
    transform: "translate(4.15 0.15)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2398",
    "data-name": "Rectangle 2398",
    width: 3,
    height: 3,
    transform: "translate(8.15 0.15)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2399",
    "data-name": "Rectangle 2399",
    width: 3,
    height: 3,
    transform: "translate(12.15 0.15)",
    fill: "current"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M5.146-5.055H3.883L3.517-6.111H1.687L1.324-5.055H.068L1.941-9.8H3.316ZM3.251-6.932,2.7-8.528a1.937,1.937,0,0,1-.086-.427H2.584a1.688,1.688,0,0,1-.09.414l-.56,1.609ZM5.788-5.055V-9.8H7.611q2.741,0,2.741,2.314A2.248,2.248,0,0,1,9.6-5.717a2.9,2.9,0,0,1-1.993.662ZM6.947-8.932v3.009h.574A1.624,1.624,0,0,0,8.7-6.34a1.511,1.511,0,0,0,.429-1.136,1.375,1.375,0,0,0-.425-1.068,1.7,1.7,0,0,0-1.193-.389Z",
    transform: "translate(2.011 14.808)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3034",
    "data-name": "Group 3034",
    transform: "translate(0 12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2388-2",
    "data-name": "Rectangle 2388",
    width: 3,
    height: 3,
    transform: "translate(0.15 0.15)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2397-2",
    "data-name": "Rectangle 2397",
    width: 3,
    height: 3,
    transform: "translate(4.15 0.15)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2398-2",
    "data-name": "Rectangle 2398",
    width: 3,
    height: 3,
    transform: "translate(8.15 0.15)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2399-2",
    "data-name": "Rectangle 2399",
    width: 3,
    height: 3,
    transform: "translate(12.15 0.15)",
    fill: "current"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertisements);
export default __webpack_public_path__ + "static/media/Advertisements.4aeed7bbba72edae7b1ebb5942d1e2d3.svg";
export { ForwardRef as ReactComponent };